import { useCallback, useMemo, useState } from 'react'
import { toast } from 'react-toastify'
import { mask } from 'remask';
import api from '../../../services/api'
import { Backdrop } from '../../../components'

import { Container, Form, Page } from './styles'

export default function GerarProcuracao() {
  const [isPF, setIsPF] = useState(true);

  const brazilianStates = useMemo(() => [
    { value: "Acre", label: "Acre" },
    { value: "Alagoas", label: "Alagoas" },
    { value: "Amapá", label: "Amapá" },
    { value: "Amazonas", label: "Amazonas" },
    { value: "Bahia", label: "Bahia" },
    { value: "Ceará", label: "Ceará" },
    { value: "Distrito Federal", label: "Distrito Federal" },
    { value: "Espírito Santo", label: "Espírito Santo" },
    { value: "Goiás", label: "Goiás" },
    { value: "Maranhão", label: "Maranhão" },
    { value: "Mato Grosso", label: "Mato Grosso" },
    { value: "Mato Grosso do Sul", label: "Mato Grosso do Sul" },
    { value: "Minas Gerais", label: "Minas Gerais" },
    { value: "Pará", label: "Pará" },
    { value: "Paraíba", label: "Paraíba" },
    { value: "Paraná", label: "Paraná" },
    { value: "Pernambuco", label: "Pernambuco" },
    { value: "Piauí", label: "Piauí" },
    { value: "Rio de Janeiro", label: "Rio de Janeiro" },
    { value: "Rio Grande do Norte", label: "Rio Grande do Norte" },
    { value: "Rio Grande do Sul", label: "Rio Grande do Sul" },
    { value: "Rondônia", label: "Rondônia" },
    { value: "Roraima", label: "Roraima" },
    { value: "Santa Catarina", label: "Santa Catarina" },
    { value: "São Paulo", label: "São Paulo" },
    { value: "Sergipe", label: "Sergipe" },
    { value: "Tocantins", label: "Tocantins" }
  ], []);

  const [fullName, setFullName] = useState('')
  const [cpf, setCpf] = useState('')
  const [concessionaria, setConcessionaria] = useState('')

  const [cep, setCEP] = useState('')
  const [address, setAddress] = useState('')
  const [numberAndComplement, setNumberAndComplement] = useState('')
  const [neighborhood, setNeighborhood] = useState('')
  const [city, setCity] = useState('');
  const [state, setState] = useState('');

  const [companyName, setCompanyName] = useState('');
  const [companyCNPJ, setCompanyCNPJ] = useState('');
  const [companyAddress, setCompanyAddress] = useState('');
  const [companyAddressNumber, setCompanyAddressNumber] = useState('');
  const [companyNeighborhood, setCompanyNeighborhood] = useState('');
  const [companyCity, setCompanyCity] = useState('');
  const [companyState, setCompanyState] = useState('');
  const [companyCEP, setCompanyCEP] = useState('');

  const handleChangeFullName = useCallback((event) => {
    setFullName(event.target.value)
  }, [setFullName]);
  const handleChangeCpf = useCallback((event) => {
    setCpf(event.target.value)
  }, [setCpf]);
  const handleChangeConcessionaria = useCallback((event) => {
    setConcessionaria(event.target.value)
  }, [setConcessionaria]);

  const handleChangeCEP = useCallback((event) => {
    setCEP(event.target.value)
  }, [setCEP]);
  const handleChangeAddress = useCallback((event) => {
    setAddress(event.target.value)
  }, [setAddress]);
  const handleChangeNumberAndComplement = useCallback((event) => {
    setNumberAndComplement(event.target.value)
  }, [setNumberAndComplement]);
  const handleChangeNeighborhood = useCallback((event) => {
    setNeighborhood(event.target.value)
  }, [setNeighborhood]);
  const handleChangeCity = useCallback((event) => {
    setCity(event.target.value)
  }, [setCity]);
  const handleChangeState = useCallback((event) => {
    setState(event.target.value)
  }, [setState]);

  const handleChangeCompanyName = useCallback((event) => {
    setCompanyName(event.target.value)
  }, [setCompanyName]);
  const handleChangeCompanyCNPJ = useCallback((event) => {
    setCompanyCNPJ(event.target.value)
  }, [setCompanyCNPJ]);
  const handleChangeCompanyAddress = useCallback((event) => {
    setCompanyAddress(event.target.value)
  }, [setCompanyAddress]);
  const handleChangeCompanyAddressNumber = useCallback((event) => {
    setCompanyAddressNumber(event.target.value)
  }, [setCompanyAddressNumber]);
  const handleChangeCompanyNeighborhood = useCallback((event) => {
    setCompanyNeighborhood(event.target.value)
  }, [setCompanyNeighborhood]);
  const handleChangeCompanyCity = useCallback((event) => {
    setCompanyCity(event.target.value)
  }, [setCompanyCity]);
  const handleChangeCompanyState = useCallback((event) => {
    setCompanyState(event.target.value)
  }, [setCompanyState]);
  const handleChangeCompanyCEP = useCallback((event) => {
    setCompanyCEP(event.target.value)
  }, [setCompanyCEP]);

  const [showBackdrop, setShowBackdrop] = useState(false)

  const onSubmitProcuracaoForm = useCallback(
    async (event) => {
      event.preventDefault()
      setShowBackdrop(true)
      if (!fullName) {
        setShowBackdrop(false)
        return toast.warn('Nome completo é obrigatório')
      }
      if (!cpf) {
        setShowBackdrop(false)
        return toast.warn('CPF é obrigatório')
      }
      if (!concessionaria) {
        setShowBackdrop(false)
        return toast.warn('Concessionária é obrigatória')
      }

      // PF
      if (isPF && !cep) {
        setShowBackdrop(false)
        return toast.warn('CEP é obrigatório')
      }
      if (isPF && !address) {
        setShowBackdrop(false)
        return toast.warn('Logradouro (endereço) é obrigatório')
      }
      if (isPF && !numberAndComplement) {
        setShowBackdrop(false)
        return toast.warn('Número é obrigatório')
      }
      if (isPF && !neighborhood) {
        setShowBackdrop(false)
        return toast.warn('Bairro é obrigatório')
      }
      if (isPF && !city) {
        setShowBackdrop(false)
        return toast.warn('Cidade é obrigatória')
      }
      if (isPF && !state) {
        setShowBackdrop(false)
        return toast.warn('Estado é obrigatório')
      }

      if(!isPF && !companyName) {
        setShowBackdrop(false)
        return toast.warn('Nome da empresa é obrigatório')
      }
      if(!isPF && !companyCNPJ) {
        setShowBackdrop(false)
        return toast.warn('CNPJ da empresa é obrigatório')
      }
      if(!isPF && !companyAddress) {
        setShowBackdrop(false)
        return toast.warn('Endereço da empresa é obrigatório')
      }
      if(!isPF && !companyAddressNumber) {
        setShowBackdrop(false)
        return toast.warn('Número do endereço da empresa é obrigatório')
      }
      if(!isPF && !companyNeighborhood) {
        setShowBackdrop(false)
        return toast.warn('Bairro do endereço da empresa é obrigatório')
      }
      if(!isPF && !companyCity) {
        setShowBackdrop(false)
        return toast.warn('Cidade do endereço da empresa é obrigatória')
      }
      if(!isPF && !companyState) {
        setShowBackdrop(false)
        return toast.warn('Estado do endereço da empresa é obrigatório')
      }
      if(!isPF && !companyCEP) {
        setShowBackdrop(false)
        return toast.warn('CEP do endereço da empresa é obrigatório')
      }

      const params = new URLSearchParams({
        is_pj: !isPF,
        full_name: fullName,
        cpf,
        concessionaria,

        // PF
        address,
        number_and_complement: numberAndComplement,
        neighborhood,
        city,
        state,
        cep,

        // PJ
        company_name: companyName,
        company_cnpj: companyCNPJ,
        company_address: companyAddress,
        company_address_number: companyAddressNumber,
        company_neighborhood: companyNeighborhood,
        company_city: companyCity,
        company_state: companyState,
        company_cep: companyCEP,
      })

      const url = `${api.defaults.baseURL}/procuracao/generate?${params}`
      await fetch(url, { headers: api.defaults.headers })
        .then(async (res) => {
          const filename = res.headers
            .get('content-disposition')
            ?.split(';')
            ?.find((n) => n.includes('filename='))
            ?.replace('filename=', '')
            ?.replaceAll('"', '')
            ?.trim()

          return {
            blob: new Blob([await res.blob()]),
            filename: filename ? decodeURI(filename) : 'procuracao.docx',
          }
        })
        .then(({ blob, filename }) => {
          const fileUrl = window.URL.createObjectURL(blob)
          const anchorTag = document.createElement('a')
          anchorTag.href = fileUrl
          anchorTag.download = filename
          document.body.appendChild(anchorTag)
          anchorTag.click()
          anchorTag.remove()
        })
        .catch((error) => {
          console.error(error)
          toast.error('Erro ao gerar procuração')
        })
        .finally(() => setShowBackdrop(false))
    },
    [
      setShowBackdrop,
      fullName,
      cpf,
      address,
      numberAndComplement,
      neighborhood,
      state,
      isPF,
      concessionaria,
      cep,
      city,
      companyName,
      companyCNPJ,
      companyAddress,
      companyAddressNumber,
      companyNeighborhood,
      companyCity,
      companyState,
      companyCEP,
    ]
  )

  return (
    <Container>
      <Page>
        <header>
          <h1>Gerar Procuração</h1>
          <div className="div__divider" />
          <span>Preencha os dados abaixo para gerar a procuração.</span>
        </header>
        <Form onSubmit={onSubmitProcuracaoForm}>
          <div className="div__select">
            <span
              className={isPF ? 's__select' : ''}
              onClick={() => {
                setIsPF(true)
              }}
            >
              Pessoa Física
            </span>
            <span
              className={!isPF ? 's__select' : ''}
              onClick={() => {
                setIsPF(false)
              }}
            >
              Pessoa Jurídica
            </span>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <input
              className="input-custom-style"
              type="text"
              name="full_name"
              value={fullName}
              placeholder="Nome completo"
              style={{ flex: 2 }}
              onChange={handleChangeFullName}
              required={isPF}
            />
            <input
              className="input-custom-style"
              type="text"
              name="cpf"
              value={mask(cpf, '999.999.999-99')}
              placeholder="CPF"
              style={{ flex: 2 }}
              onChange={handleChangeCpf}
              required={isPF}
            />
            <input
              className="input-custom-style"
              type="text"
              name="concessionaria"
              value={concessionaria}
              placeholder="Concessionária"
              style={{ flex: 2 }}
              onChange={handleChangeConcessionaria}
              required={isPF}
            />
            {isPF && (
              <>
                <input
                  className="input-custom-style"
                  type="text"
                  name="cep"
                  value={mask(cep, '99999-999')}
                  placeholder="CEP"
                  style={{ flex: 2 }}
                  onChange={handleChangeCEP}
                  required
                />
                <input
                  className="input-custom-style"
                  type="text"
                  name="address"
                  value={address}
                  placeholder="Logradouro"
                  style={{ flex: 2 }}
                  onChange={handleChangeAddress}
                  required
                />
                <input
                  className="input-custom-style"
                  type="text"
                  name="number_and_complement"
                  value={numberAndComplement}
                  placeholder="Número e complemento (se houver)"
                  style={{ flex: 2 }}
                  onChange={handleChangeNumberAndComplement}
                  required
                />
                <input
                  className="input-custom-style"
                  type="text"
                  name="neighborhood"
                  value={neighborhood}
                  placeholder="Bairro"
                  style={{ flex: 2 }}
                  onChange={handleChangeNeighborhood}
                  required
                />
                <input
                  className="input-custom-style"
                  type="text"
                  name="city"
                  value={city}
                  placeholder="Cidade"
                  style={{ flex: 2 }}
                  onChange={handleChangeCity}
                  required
                />
                <select
                  className="select-custom-style"
                  name="state"
                  value={state}
                  style={{ flex: 2 }}
                  onChange={handleChangeState}
                  required
                >
                  <option value="" disabled>
                    Selecione um Estado
                  </option>
                  {brazilianStates.map((state) => (
                    <option key={state.value} value={state.value}>
                      {state.label}
                    </option>
                  ))}
                </select>
              </>
            )}
          </div>
          {!isPF && (
            <>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              > 
                <input
                  className="input-custom-style"
                  type="text"
                  name="company_name"
                  value={companyName}
                  placeholder="Nome da empresa"
                  style={{ flex: 2 }}
                  onChange={handleChangeCompanyName}
                  required
                />
                <input
                  className="input-custom-style"
                  type="text"
                  name="company_cnpj"
                  value={mask(companyCNPJ, '99.999.999/9999-99')}
                  placeholder="CNPJ da empresa"
                  style={{ flex: 2 }}
                  onChange={handleChangeCompanyCNPJ}
                  required
                />
                <input
                  className="input-custom-style"
                  type="text"
                  name="company_address"
                  value={companyAddress}
                  placeholder="Endereço da empresa"
                  style={{ flex: 2 }}
                  onChange={handleChangeCompanyAddress}
                  required
                />
                <input
                  className="input-custom-style"
                  type="text"
                  name="company_address_number"
                  value={companyAddressNumber}
                  placeholder="Número do endereço da empresa"
                  style={{ flex: 2 }}
                  onChange={handleChangeCompanyAddressNumber}
                  required
                />
                <input
                  className="input-custom-style"
                  type="text"
                  name="company_neighborhood"
                  value={companyNeighborhood}
                  placeholder="Bairro do endereço da empresa"
                  style={{ flex: 2 }}
                  onChange={handleChangeCompanyNeighborhood}
                  required
                />
                <input
                  className="input-custom-style"
                  type="text"
                  name="company_city"
                  value={companyCity}
                  placeholder="Cidade do endereço da empresa"
                  style={{ flex: 2 }}
                  onChange={handleChangeCompanyCity}
                  required
                />
                <select
                  className="select-custom-style"
                  name="company_state"
                  value={companyState}
                  style={{ flex: 2 }}
                  onChange={handleChangeCompanyState}
                  required
                >
                  <option value="" disabled>
                    Selecione um Estado
                  </option>
                  {brazilianStates.map((state) => (
                    <option key={state.value} value={state.value}>
                      {state.label}
                    </option>
                  ))}
                </select>
                <input
                  className="input-custom-style"
                  type="text"
                  name="company_cep"
                  value={mask(companyCEP, '99999-999')}
                  placeholder="CEP do endereço da empresa"
                  style={{ flex: 2 }}
                  onChange={handleChangeCompanyCEP}
                  required
                />
              </div>
            </>
          )}
          <button
            type="submit"
            className="primary-button-style"
            style={{ margin: '1rem auto' }}
          >
            Gerar Procuração
          </button>
        </Form>
      </Page>
      {showBackdrop && (
        <Backdrop message="Gerando procuração, por favor aguarde." />
      )}
    </Container>
  )
}
